<template>
	<router-view />
	<Toast />
	<ConfirmDialog></ConfirmDialog>
	<UiLoader />
</template>

<script setup>
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import UiLoader from '@/components/Ui/Loader.vue';
</script>
